const ReplaceChar = (texto) =>
  texto
    .replace(/“/g, "\"")
    .replace(/”/g, "\"")
    .replace(/–/g, "-")
    .replace(/‘/g, "'")
    .replace(/’/g, "'")
    .replace(/–/g, "-")
    .replace(/–/g, "-");

export default ReplaceChar;
